define 'controller/GeneralSwiperSliderController', ['jquery', 'lib/swiper-bundle.min'], ($) ->
  class GeneralSwiperSliderController

    constructor: (@$el) ->
      @swiper = new Swiper @$el[0],
        lazy: true,
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true
        },
        navigation: {
          nextEl: '.general-slider__button-next',
          prevEl: '.general-slider__button-prev'
        },
        breakpoints: {
          767: {
            spaceBetween: 24
          }
        }

    destroy: ->
      @$el.off()
